import { OverlayModule } from '@angular/cdk/overlay';
import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';

export interface AuxSelectConfig {
  data: string[];
  header: string;
  options: string[];

  selected?: string;
  showArrowDown?: boolean;
  showArrowUp?: boolean;
  sub?: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, OverlayModule],
  selector: 'aux-card-select',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  templateUrl: './aux-card-select.component.html',
})
export class AuxCardSelectComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);

  _config: AuxSelectConfig = {
    data: [],
    header: '',
    options: [],
  };
  _loading = false;
  highlighted: null | number = null;
  isListOpen = false;
  optionCount = 0;
  selected: string | undefined;
  selectedIndex = 0;

  ngOnInit(): void {
    this.selectFirstItem();
  }

  closeList() {
    this.isListOpen = false;
    this.highlighted = null;
    this.cdr.detectChanges();
  }

  get config(): AuxSelectConfig {
    return this._config;
  }

  @Input() set config(config: AuxSelectConfig) {
    this._config = config;

    if (this.selected == null) {
      this.selectFirstItem();
    }
  }

  highlightOption(index: number): void {
    this.highlighted = index;
  }

  get loading() {
    return this._loading;
  }

  @Input() set loading(loading: boolean) {
    this._loading = loading;
  }

  onListKeydown(keydownEvent: KeyboardEvent): void {
    keydownEvent.preventDefault();
    // tslint:disable-next-line: deprecation
    switch (keydownEvent.key) {
      case 'ArrowDown':
        if (this.highlighted) {
          const index2 = this.highlighted + 1 > this.optionCount - 1 ? 0 : this.highlighted + 1;

          this.highlightOption(index2);
        }

        break;
      case 'ArrowUp':
        if (this.highlighted) {
          const index = this.highlighted - 1 < 0 ? this.optionCount - 1 : this.highlighted - 1;

          this.highlightOption(index);
        }

        break;
      case 'Enter':
      case 'Space':
        this.selectOption();
        break;
      case 'Escape':
        this.closeList();
        break;
      default:
        break;
    }
  }

  openList() {
    this.isListOpen = true;

    if (this.selectedIndex != null) {
      this.highlighted = this.selectedIndex;
    } else {
      this.highlighted = 0;
    }

    this.cdr.detectChanges();
  }

  selectFirstItem() {
    let itemIdx = -1;

    if (this.config.selected) {
      itemIdx = this.config.options.indexOf(this.config.selected);
    }

    this.optionCount = this.config.options.length;

    if (this.config.options.length) {
      this.highlightOption(itemIdx === -1 ? 0 : itemIdx);
      this.selectOption();
    }
  }

  selectOption(): void {
    const index = this.highlighted;

    if (index != null) {
      this.selected = this.config.options[index];
      this.selectedIndex = index;
      this.closeList();
    }
  }
}
